import React, { useRef } from 'react'
import { IconButton } from '../../../ui'

const SESSION_COLOR = 'var(--clay-600)'

export function OwnerList({ items = [], onChange, maxItems = 10, maxChars = 140, readOnly = false }) {
  const inputRefs = useRef([])

  function update(index, patch) {
    const next = items.map((item, i) => (i === index ? { ...item, ...patch } : item))
    onChange({ items: next })
  }

  function handleAdd() {
    if (items.length >= maxItems) return
    onChange({ items: [...items, { text: '', ownerReport: false, ownerManager: false }] })
    setTimeout(() => inputRefs.current[items.length]?.focus(), 0)
  }

  function handleRemove(index) {
    onChange({ items: items.filter((_, i) => i !== index) })
  }

  function handleKeyDown(e, index) {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleAdd()
    } else if (e.key === 'Backspace' && items[index]?.text === '' && items.length > 0) {
      e.preventDefault()
      handleRemove(index)
      setTimeout(() => inputRefs.current[Math.max(0, index - 1)]?.focus(), 0)
    }
  }

  return (
    <div style={styles.wrap}>
      {items.map((item, index) => (
        <div key={index} style={styles.row}>
          <input
            ref={(el) => { inputRefs.current[index] = el }}
            style={styles.input}
            value={item.text}
            maxLength={maxChars}
            disabled={readOnly}
            placeholder={readOnly ? '' : 'Commitment…'}
            onChange={(e) => update(index, { text: e.target.value })}
            onKeyDown={(e) => handleKeyDown(e, index)}
            aria-label={`Commitment ${index + 1}`}
          />
          <div style={styles.ownerBadges}>
            <button
              style={{
                ...styles.badge,
                ...(item.ownerReport ? styles.badgeActive : styles.badgeInactive),
              }}
              onClick={() => !readOnly && update(index, { ownerReport: !item.ownerReport })}
              disabled={readOnly}
              aria-label="Toggle report ownership"
              aria-pressed={item.ownerReport}
            >R</button>
            <button
              style={{
                ...styles.badge,
                ...(item.ownerManager ? styles.badgeActive : styles.badgeInactive),
              }}
              onClick={() => !readOnly && update(index, { ownerManager: !item.ownerManager })}
              disabled={readOnly}
              aria-label="Toggle manager ownership"
              aria-pressed={item.ownerManager}
            >M</button>
          </div>
          {!readOnly && (
            <IconButton ariaLabel="Remove item" onClick={() => handleRemove(index)} tabIndex={-1}>×</IconButton>
          )}
        </div>
      ))}
      {!readOnly && items.length < maxItems && (
        <button style={styles.addBtn} onClick={handleAdd}>+ add commitment</button>
      )}
    </div>
  )
}

const styles = {
  wrap: { padding: '10px 12px 12px', display: 'flex', flexDirection: 'column', gap: '5px' },
  row: { display: 'flex', alignItems: 'center', gap: '6px' },
  input: {
    flex: 1, border: 'none', outline: 'none', background: 'transparent',
    fontSize: '12px', color: 'var(--text-primary)', lineHeight: '1.5', padding: '2px 0',
  },
  ownerBadges: { display: 'flex', gap: '3px', flexShrink: 0 },
  badge: {
    width: '18px', height: '18px', borderRadius: '9px',
    fontSize: '9px', fontWeight: 700, border: 'none',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', lineHeight: 1, flexShrink: 0,
  },
  badgeActive: { background: SESSION_COLOR, color: '#fff' },
  badgeInactive: { background: '#f0ecf4', color: '#9b9b9b', border: '1px solid #ddd' },
  addBtn: {
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '11px',
    color: SESSION_COLOR, padding: '2px 0', marginLeft: '4px', marginTop: '2px', textAlign: 'left',
  },
}
